import script from "./dpc-chat-message-extension-image.vue?vue&type=script&setup=true&lang=js"
export * from "./dpc-chat-message-extension-image.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__